import { render, staticRenderFns } from "./my-examine.vue?vue&type=template&id=c6b88630"
import script from "./my-examine.vue?vue&type=script&lang=js"
export * from "./my-examine.vue?vue&type=script&lang=js"
import style0 from "./my-examine.vue?vue&type=style&index=0&id=c6b88630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports